import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class ConciliationRequest extends CrudRequest {
  static baseUrl() {
    return '/cashintransfer/conciliation';
  }

  static listSuggestions(id) {
    return httpService.get(
      `${this.baseUrl()}/${id}/suggestions`,
    );
  }

  static conciliation(payload) {
    return httpService.patch(
      `${this.baseUrl()}`,
      payload,
    );
  }
}
